export default "__VITE_ASSET__ec06d04e__"